<script>
import dayjs from 'dayjs';
import { defineComponent } from 'vue';
import menuIconOpen from '@/assets/icons/close_white_36dp.svg';
import menuIconClosed from '@/assets/icons/menu_white_36dp.svg';

export default defineComponent({
  props: {
    empresa: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMenuOpen: false
    },
    {
      currentTime: dayjs().format('HH:mm:ss')
    }
  },
  computed: {
    menuIcon() {
      return this.isMenuOpen ? menuIconOpen : menuIconClosed;
    }
  },
  mounted() {
    setInterval(() => {
      this.currentTime = dayjs().format('HH:mm:ss');
    }, 1000);
  },
  methods: {
    home(){
      this.$router.push('/');
    }
  }
});
</script>


<template>
  <nav>
    <button @click="home">

      <div class="logomain">
      <img v-if="empresa === 'GRUPOPARQUE'" class="logogruposolo" style="height: 50px;  padding: 4px;" src="../../public/logos/GRUPOPARQUE.png" alt="">
      
      <img v-else-if="empresa === 'previda'" class="logoempresas" src="../../public/logos/previda.png" alt="Logo" />
      <img v-else-if="empresa === 'parquedasflores'" class="logoempresas" src="../../public/logos/parquedasflores.png" alt="Logo" />
      <img v-else-if="empresa === 'cemiterioprevida'" class="logoempresas" src="../../public/logos/cemiterioprevida.png" alt="Logo" />
      <img v-else-if="empresa === 'parquedoagreste'" class="logoempresas" src="../../public/logos/parquedoagreste.png" alt="Logo" />
      <img v-else-if="empresa === 'memorialparque'" class="logoempresas" src="../../public/logos/memorialparque.png" alt="Logo" />

      <img v-if="empresa != 'GRUPOPARQUE'" class="logogrupo" style="height: 50px;  padding: 4px;" src="../../public/logos/GRUPOPARQUE.png" alt="">

    </div>
    </button>
    <div class="nav-list">
      <p>{{ currentTime }}</p>
    </div>
  </nav>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap');

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Sora", sans-serif;
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #343F53;
  height: 12vh;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}
button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.div-nav {
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-nav-img {
  height: 30px;
}

p {
  color: #fff;
  text-decoration: none;
  transition: 0.3s;
  font-weight: 600;
  font-size: 26px;
}

.nav-list p:hover {
  opacity: 0.5;
}

nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #343F53;
  height: 12vh;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.nav-list {
  list-style: none;
  display: flex;
  gap: 1rem;
  width: 8rem;
  align-items: center;
  justify-content: center;
}


.logomain {
  height: 90px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.logomain img{
  width: 100%;
  height: 100%;
}


@media screen and (max-width: 815px) {

  nav {
    padding: 1.5rem 2rem;
  }

  p {

    font-size: 20px;
  }
  .logogrupo {
    display: none;
  }
  .logomain .logoempresas{
    width: 100px;
  }
  .logomain .logogruposolo {
    width: 180px;
  }
}
</style>
